import { HHTooltip } from '@hinge-health/react-component-library';
import { DeleteRounded, Edit } from '@mui/icons-material';
import { GridActionsCellItem } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import { tabRoutes } from '../../constants/hinge-connect-constants.constant';
import { actionButtonText, rulesRoutes } from '../constants/rules.constant';

export const EditActionButton = ({
  ruleId,
  url,
}: {
  ruleId: string;
  url?: string;
}): JSX.Element => {
  const navigate = useNavigate();

  return (
    <HHTooltip hhVariant="variant-bypass" title={actionButtonText.edit} arrow>
      <GridActionsCellItem
        id="edit-rule-button"
        data-testid="edit-rule-button"
        label={actionButtonText.edit}
        icon={<Edit />}
        color="primary"
        onClick={(): void => {
          navigate(
            url ||
              `/${tabRoutes.baseRoute}/${tabRoutes.rules}/${ruleId}/${rulesRoutes.edit}`,
          );
        }}
      />
    </HHTooltip>
  );
};

// The Delete modal is owned by the grid (useRuleActionModals), not the cell
export const DeleteActionButton = ({
  onClick,
}: {
  onClick: () => void;
}): JSX.Element => (
  <HHTooltip hhVariant="bottom" title={actionButtonText.delete}>
    <GridActionsCellItem
      id="delete-rule-button"
      data-testid="delete-rule-button"
      label={actionButtonText.delete}
      icon={<DeleteRounded />}
      color="error"
      onClick={onClick}
    />
  </HHTooltip>
);
